import tenantConfigurationService from "@/services/tenantConfigurationService"
import {errorHttpMessage} from "@/utils/errorDecodeUtil"

export const getTenantById = async ({commit}, tenantId) => {
  try {
    const {data: result} = await tenantConfigurationService.getTenantById(tenantId)
    return result.result;
  } catch (ex) {
    // const error_http_message = errorHttpMessage(ex);
    return {
      // message: error_http_message?.message,
      // error_keys: error_http_message?.error_keys,
      // data: ex?.response?.data,
      error: true,
    };
  }
}

export const updateTenant = async ({commit}, {id, data}) => {
  try {
    const {data: result} = await tenantConfigurationService.updateTenant(id, data)
    return result.result;
  } catch (ex) {
    return {
      error: true,
    };
  }
}